module.exports = __webpack_public_path__ + "img/alibi-logo.f4dea204.svg";